module.exports = __webpack_public_path__ + "img/child_care_icon.dd8fcdab.png";